import styled from 'styled-components';
import { PRIMARY } from '../../styles/colors';

// Cast to avoid ts(2883) portability error caused by @types/react version
// mismatch between packages/ui and other packages in the monorepo.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ButtonContainer = (styled.div<{ $strokeWidth?: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  padding: 9px;
  border: ${({ $strokeWidth }) => $strokeWidth}px solid ${PRIMARY};
  cursor: pointer;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
